module.exports = __webpack_public_path__ + "img/farmaconAntes.9b81e50a.png";